import React from 'react';
import { Divider, Typography } from 'antd';
import zoneStore from '../../Store';
import { findOrphans } from '../../../utils/flowAnalysis';
import ScreenNode from './ScreenNode';

function OrphansRow() {
  const screens = zoneStore.useState((s) => s.config.screens);
  const orphans = findOrphans(screens);

  if (orphans.length === 0) return null;

  return (
    <div>
      <Divider orientation="left" plain>
        <Typography.Text type="secondary">
          Не в потоке — до этих экранов нельзя дойти от стартового
        </Typography.Text>
      </Divider>
      <div>
        {orphans.map((screen) => (
          <div style={{ marginBottom: 12 }} key={screen.screenId}>
            <ScreenNode screen={screen} ancestors={[]} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default OrphansRow;
